import { ReferralPartnerServiceClient } from '@pushwoosh/rpc-service-client/pushwoosh/referral_partners/Referral-partnersServiceClientPb';

import {
  CreateRequest,
  CreateResponse,
  GetRequest,
  GetResponse,
  GetWithdrawalsHistoryRequest,
  GetWithdrawalsHistoryResponse,
  GetTotalStatisticsRequest,
  GetTotalStatisticsResponse,
  UpdateWithdrawalInfoRequest,
  UpdateWithdrawalInfoResponse,
  CreateWithdrawalRequest,
  CreateWithdrawalResponse,
  GetWithdrawalAdditionalInfoRequest,
  GetWithdrawalAdditionalInfoResponse,
  GetCurrenciesRequest,
  GetCurrenciesResponse,
} from '@pushwoosh/rpc-service-client/pushwoosh/referral_partners/referral-partners_pb';

export type ReferralPartnersExportClasses = {
  ReferralPartnerServiceClient: typeof ReferralPartnerServiceClient;
  CreateRequest: typeof CreateRequest;
  CreateResponse: typeof CreateResponse;
  GetRequest: typeof GetRequest;
  GetResponse: typeof GetResponse;
  GetWithdrawalsHistoryRequest: typeof GetWithdrawalsHistoryRequest;
  GetWithdrawalsHistoryResponse: typeof GetWithdrawalsHistoryResponse;
  GetTotalStatisticsRequest: typeof GetTotalStatisticsRequest;
  GetTotalStatisticsResponse: typeof GetTotalStatisticsResponse;
  UpdateWithdrawalInfoRequest: typeof UpdateWithdrawalInfoRequest;
  UpdateWithdrawalInfoResponse: typeof UpdateWithdrawalInfoResponse;
  CreateWithdrawalRequest: typeof CreateWithdrawalRequest;
  CreateWithdrawalResponse: typeof CreateWithdrawalResponse;
  GetWithdrawalAdditionalInfoRequest: typeof GetWithdrawalAdditionalInfoRequest;
  GetWithdrawalAdditionalInfoResponse: typeof GetWithdrawalAdditionalInfoResponse;
  GetCurrenciesRequest: typeof GetCurrenciesRequest;
  GetCurrenciesResponse: typeof GetCurrenciesResponse;
};

export const referralPartners: ReferralPartnersExportClasses = {
  ReferralPartnerServiceClient,
  CreateRequest,
  CreateResponse,
  GetRequest,
  GetResponse,
  GetWithdrawalsHistoryRequest,
  GetWithdrawalsHistoryResponse,
  GetTotalStatisticsRequest,
  GetTotalStatisticsResponse,
  UpdateWithdrawalInfoRequest,
  UpdateWithdrawalInfoResponse,
  CreateWithdrawalRequest,
  CreateWithdrawalResponse,
  GetWithdrawalAdditionalInfoRequest,
  GetWithdrawalAdditionalInfoResponse,
  GetCurrenciesRequest,
  GetCurrenciesResponse,
};
